import React from 'react';
import styles from './About.module.css';
import logo from './imgs/logo.png';

function About() {
    return (
        <div className={styles.aboutContainer}>
            <div className={styles.aboutHeader}>
                <img src={logo} alt="Rustic Yarns Logo" style={{width: '90px', borderRadius: '50%', marginBottom: '1rem', boxShadow: '0 2px 12px 0 #e6b8a2'}} />
                <div className={styles.aboutTitle}>About Rustic Yarns</div>
                <div className={styles.aboutSubtitle}>Weaving Tradition with Creativity</div>
            </div>
            <div className={styles.aboutContent}>
                <section>
                    <h2>Our Story</h2>
                    <p>
                        Rustic Yarns was founded with a vision to revive the age-old art of fiber crafting while promoting sustainability and mindful craftsmanship. Our journey began with a single idea: to provide artisans and hobbyists with top-quality, eco-friendly yarns that inspire creativity and reconnect them with nature. Every skein of yarn, every tool, and every course we offer reflects our passion for traditional craftsmanship and our dedication to sustainable practices.
                    </p>
                </section>
                <section>
                    <h2>What We Offer</h2>
                    <ul>
                        <li>
                            <strong>Courses:</strong> Dive into the world of fiber arts through our expert-led courses, covering everything from knitting basics to advanced techniques in weaving and crochet. Whether you prefer in-person or online learning, our courses are designed to fit all skill levels.
                        </li>
                        <li>
                            <strong>Products:</strong> We curate a selection of yarns, needles, hooks, and essential tools made from natural, high-quality materials. Our products are carefully sourced to ensure durability and comfort, giving you the tools to turn ideas into beautiful handmade creations.
                        </li>
                        <li>
                            <strong>Vision:</strong> Our vision is to help all mothers, women, and girls know the value of art, make them aware of all types of craft, help their mental health, and make them happier and more creative in daily life.
                        </li>
                    </ul>
                </section>
                <section>
                    <h2>Our Commitment to Sustainability</h2>
                    <p>
                        We’re committed to making a positive impact on our environment and community. Our yarns are made from ethically sourced, natural fibers, and we prioritize suppliers who share our dedication to sustainable practices. From eco-friendly dyes to biodegradable packaging, every step of our process is designed with the Earth in mind.
                    </p>
                </section>
                <section>
                    <h2>Message from the CEO</h2>
                    <div className={styles.ceoInfo}>
                        <img src={logo} alt="CEO of Rustic Yarns" className={styles.ceoImage}/>
                        <p>
                            <strong>Bhavika Ratadia</strong>, Founder & CEO of Rustic Yarns, holds a special degree in the fashion world and secured a position in the best creative art session for the magazine of 2008.<br/><br/>
                            Never thought of doing something of her interest in the future and growing her own business on a small scale. Being a housewife, she started pursuing her dreams toward the craft and began sharing her knowledge with others by taking classes and educating others to grow and follow their dreams in some way.<br/><br/>
                            Rustic Yarns has become her business by selling products and also by educating all by teaching this art.
                        </p>
                    </div>
                </section>
            </div>
            <div className={styles.aboutFooter}>
                Thank you for being part of our journey. Together, let’s create a more beautiful, sustainable world—one stitch at a time!
            </div>
        </div>
    );
}

export default About;
